import React, { FC } from "react";
import styled from "styled-components";
import { GRAY } from "../styles/constants";

interface Props {
  label: string;
  htmlFor?: string;
}
const CompName: FC<Props> = ({ label, children, htmlFor, ...props }) => {
  return (
    <Wrap {...props}>
      <Label htmlFor={htmlFor}>{label}</Label>
      {children}
    </Wrap>
  );
};

const Wrap = styled.div`
  margin: 20px 0;
`;

const Label = styled.label`
  display: block;
  color: ${GRAY};
  margin-bottom: 0.25em;
`;

export default CompName;
